import myaxios from "../Axios";


export function putWizard(data:any) {
    myaxios.put(`/ajax/settings/extra-data?entity=frontend`, {
        data: {wizard: JSON.stringify(data)}
    }).then(res => {

    })
}